import {handleResponse} from "@/services/handleresponse";


export const LocationService = {
    getProvinsi(){
        return fetch('https://api.irmastore.id/public/province', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        }).then(handleResponse)
            .then(data => {
                return data
            })
    },
    getCity(v){
        return fetch('https://api.irmastore.id/public/city?province='+v.province_id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        }).then(handleResponse)
            .then(data => {
                return data
            })
    },
    getKecamatan(v){
        return fetch('https://api.irmastore.id/public/subdistrict?city='+v.city_id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        }).then(handleResponse)
            .then(data => {
                return data
            })
    }
}
